import { useState } from 'react'
import { Box } from '@mui/material'
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded'
import Link from 'next/link'
import { statsigLog } from '@/lib/statsigAndGa'
import { popularShow } from '@/state/popular'
// import { statsigLog } from '../../lib/statsigAndGa'
import { useIntl } from 'react-intl'
import HouseLogo from '@/components/icons/houseLogo'
import { feedbackInfo } from '@/state/feedback'
import useFeedbackTimeMonitor from '@/hooks/useFeedbackTimeMonitor'
import Facebook from '../icons/footer/facebook'
import Twitter from '../icons/footer/twitter'
import Instagram from '../icons/footer/instagram'
import Youtube from '../icons/footer/youtube'
import TikTok from '../icons/newHome/tikTok'
import Feedback from '../feedback'

const CURRENT_YEAR = new Date().getFullYear()

const Footer = () => {
  const intl = useIntl()
  const [inFoot, setInFoot] = useState(false)

  const handleClickMore = (flag: boolean) => {
    setInFoot(flag)
  }

  const handleOpen = () => {
    popularShow(true)
    statsigLog('popular_searches_click')
  }

  const list = [
    {
      url: 'https://www.facebook.com/RentyAi',
      icon: <Facebook className="w-4 h-4" color={inFoot ? '' : '#B0B0B0'} />,
      title: 'Tripalink Facebook'
    },
    {
      url: 'https://twitter.com/RentyAi',
      icon: <Twitter className="w-4 h-4" color={inFoot ? '' : '#B0B0B0'} />,
      title: 'Tripalink Twitter'
    },
    {
      url: 'https://instagram.com/renty.ai?igshid=OGQ5ZDc2ODk2ZA==',
      icon: <Instagram className="w-4 h-4" color={inFoot ? '' : '#B0B0B0'} />,
      title: 'Tripalink Instagram'
    },
    {
      url: 'https://www.youtube.com/channel/UCUFb-jAiIo8bsVgYHEfXpTQ',
      icon: <Youtube className="w-4 h-4" color={inFoot ? '' : '#B0B0B0'} />,
      title: 'Tripalink Youtube'
    },
    {
      url: 'https://www.tiktok.com/@renty.ai',
      icon: <TikTok className="w-4 h-4" color={inFoot ? '' : '#B0B0B0'} />,
      title: 'Renty Tiktok'
    }
  ]
  useFeedbackTimeMonitor()
  return (
    <Box
      component="footer"
      className="bg-gray-200 pl-10 py-1 relative pr-20"
      onMouseEnter={() => handleClickMore(true)}
      onMouseLeave={() => handleClickMore(false)}
    >
      <div className="flex items-center justify-between max-w-[1440px] mx-auto">
        <div className="text-xs text-[#75798D]">
          © {CURRENT_YEAR} Renty.AI Inc. All Rights Reserved
        </div>
        <div className="flex items-center gap-4 leading-4">
          <HouseLogo className="w-4 h-4 pt-[2px]" />
          {list.map(item => (
            <Link
              href={item.url}
              target="_blank"
              key={item.url}
              title={item.title}
              className="hover:scale-150 transition-transform"
              style={{
                transformOrigin: 'bottom'
              }}
            >
              {item.icon}
            </Link>
          ))}
          <Box
            component="div"
            className="text-xs text-secondary flex items-center cursor-pointer"
            onClick={handleOpen}
          >
            <span>{intl.formatMessage({ id: 'global.popular.searches' })} </span>
            <KeyboardArrowDownRoundedIcon className="text-sm text-secondary" />
          </Box>
        </div>
      </div>
      <Box
        className="absolute top-0 bottom-0 right-0 z-10 py-1 px-2 text-white text-xs font-semibold bg-[#226643] rounded-tl-[8px] cursor-pointer"
        onClick={() => {
          statsigLog('feedback_popup_open', { entry_point: 'footer-button' })
          feedbackInfo({ visible: true })
        }}
      >
        Feedback
      </Box>
      <Feedback />
    </Box>
  )
}

export default Footer
